import { render, staticRenderFns } from "./StatisticCardVerticalSad.vue?vue&type=template&id=38a539ec&"
import script from "./StatisticCardVerticalSad.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalSad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports